import { render } from "./resetPwd.vue?vue&type=template&id=558e0083&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"

import "./resetPwd.vue?vue&type=style&index=0&id=558e0083&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558e0083"]])

export default __exports__